var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.85,
    y: 0.85,
    width: 40.3,
    height: 40.3069,
    rx: 8.15,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.85,
    y: 0.85,
    width: 40.3,
    height: 40.3069,
    rx: 8.15,
    stroke: "#8E9EAB",
    strokeWidth: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 31.0063H30",
    stroke: "#00ABFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2603 12.6011L14.0503 21.2936C13.7403 21.6237 13.4403 22.2739 13.3803 22.724L13.0103 25.9649C12.8803 27.1353 13.7203 27.9355 14.8803 27.7355L18.1003 27.1853C18.5503 27.1053 19.1803 26.7752 19.4903 26.4351L27.7003 17.7426C29.1203 16.2422 29.7603 14.5317 27.5503 12.4411C25.3503 10.3705 23.6803 11.1007 22.2603 12.6011Z",
    stroke: "#00ABFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8896 14.0515C21.3196 16.8123 23.5596 18.9229 26.3396 19.203",
    stroke: "#00ABFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionEdit);
export default __webpack_public_path__ + "static/media/sectionEdit.b69c9a85334c40f79895f87373334a9c.svg";
export { ForwardRef as ReactComponent };